module.exports = __webpack_public_path__ + "fonts/iconfont.47e1c525.ttf";